import { combineReducers } from 'redux';
import authReducer from '../reducers/authReducer';
import routeReducer from './routeReducer';
import filterReducer from './filterReducer';
export default combineReducers({
    auth: authReducer,
    route: routeReducer,
    moduleFilter: filterReducer,
});